
import PropTypes from 'prop-types';
import React from 'react';
import Base from './Base';
import config from './config';

/**
 * Inline-block element for adding space between elements
 */

const Space = ({ x = 1, auto, children, ...props }) => {
  const { scale } = config;

  return (
    <Base
      {...props}
      className="Space"
      baseStyle={{
        display: 'inline-block',
        flex: auto ? '1 1 auto' : null,
        width: scale[x],
      }}
    />
  );
};

Space.propTypes = {
  /** Width of space based on the spacing scale */
  x: PropTypes.oneOf([1, 2, 3, 4]),
  /** Sets flex: 1 1 auto */
  auto: PropTypes.bool,
};

export default Space;

